export default __webpack_public_path__ + "media/images/logo-black-2d9a1e46.svg";